import { EditEntityBaseClass } from '../EditEntityBaseClass';
import { Component, OnInit } from '@angular/core';
import { VestmentColorService } from '../../services/vestment-color.service';
import { VestmentColor } from '../../../../objects';
import { MatDialogRef } from '@angular/material/dialog';
import { ReligionBranchServiceService, ReligionBranchSummary } from '../../services/religion-branch.service';

@Component({
  selector: 'app-vestment-color-edit',
  templateUrl: './vestment-color-edit.component.html',
  styleUrls: ['./vestment-color-edit.component.css']
})
export class VestmentColorEditComponent extends EditEntityBaseClass  implements OnInit {

  public religionBranches: ReligionBranchSummary[];

  constructor(
    private vestmentColorSvc: VestmentColorService,
    private religionBranchSvc: ReligionBranchServiceService,
    private dialog: MatDialogRef<VestmentColorEditComponent>
  ) {
    super();
  }

  ngOnInit() {

    this.listsLoaded = false;

    var religionBranchPromise = this.religionBranchSvc.loadEntities().then(
      (data) => {
        this.religionBranches = data;
      }
    )

    Promise.all([religionBranchPromise]).then(
      (data) => {
        console.log("All promises are completed");
        this.listsLoaded = true;
      }
    );

  }

  public LoadItem(itemId: any) {
    if (itemId) {
      this.vestmentColorSvc.getItem(itemId).then(
        (data: VestmentColor) => {
          this.item = data;
          this.listsLoaded = true;
          console.log(data);

          if (this.item != null && this.item.Localized != null) {
            this.currentLocalizedData = this.item.Localized[0];
          }

        }
      )
    }
  }

  public cancel() {
    this.dialog.close();
  }

  public save() {
    console.log(this.item);

    this.vestmentColorSvc.save(this.item).then(
      (data) => {
        console.log(data);
        this.dialog.close(data);
      }
    ).catch(
      (err) => {
        console.log("error", err);
      }
    )

  }


}
